export enum AccreditationChannelEnum {
    FISERV_ONLINE = 'Fiserv Online',
    CEF_BULK = 'Pré Proposta Caixa',
    WHATSAPP_APP = 'Whatsapp Pay',
    CARAT = 'Portal do Carat',
    MARKETPLACE = 'Marketplace',
}
